import { css, type Theme } from "@emotion/react";
import { borders, typography } from "aviary-tokens";
import type { EditorThemeClasses } from "lexical";

import { utilities } from "@styles";

export const base = (theme: Theme) => css`
  .editor-paragraph {
    color: ${theme.ds5.neutral.text};
    font-family: ${theme.aviaryTypography.body.fontFamily};
    font-size: ${theme.aviaryTypography.body.fontSize};
    font-weight: ${theme.aviaryTypography.body.fontWeight};
  }

  .editor-text-bold {
    font-weight: ${typography.weightSemiBold};
  }
  .editor-text-italic {
    font-style: italic;
  }

  .editor-list-ul {
    padding: 0;
    margin: 0;
    margin-left: 1.5rem;
    list-style: disc;
  }

  .editor-list-ol {
    padding: 0;
    margin: 0;
    margin-left: 1.5rem;
  }

  .editor-nested-listitem {
    list-style-type: none;
  }

  .editor-h2 {
    color: ${theme.text.emphasis};
    font-size: ${theme.aviaryTypography.h4.fontSize};
  }
  .editor-h3 {
    color: ${theme.text.emphasis};
    font-size: ${theme.aviaryTypography.h4.fontSize};
    font-weight: ${theme.aviaryTypography.h4.fontWeight};
  }
  .editor-link {
    color: ${theme.success.textBase};
    text-decoration: underline;

    &:hover {
      color: ${theme.success.textHover};
      text-decoration: none;
    }
    &:active {
      color: ${theme.success.textActive};
      text-decoration: none;
    }
  }
`;

export const textArea = css`
  padding: 1rem 1rem 1.5rem 1rem;
  &:focus-visible {
    outline: none;
  }
`;

export const placeholder = (theme: Theme) => css`
  color: ${theme.input.textPlaceholder};
  position: absolute;
  top: 15px;
  left: 15px;
  pointer-events: none;
`;

export const wrapper = (theme: Theme) => css`
  border: 1px solid ${theme.system.borderBase};
  border-radius: ${borders.radiusBase};
  ${utilities.transition}
  transform-style: preserve-3d;

  &:hover {
    border-color: ${theme.system.borderHover};
  }
  &:focus-within {
    border-color: ${theme.primary.borderActive};
  }
`;

// Lexical theme/class names for styling components

export const RichTextEditorTheme: EditorThemeClasses = {
  paragraph: "editor-paragraph",
  text: {
    bold: "editor-text-bold",
    italic: "editor-text-italic",
  },
  list: {
    nested: {
      listitem: "editor-nested-listitem",
    },
    ul: "editor-list-ul",
    ol: "editor-list-ol",
  },
  heading: {
    h2: "editor-h2",
    h3: "editor-h3",
  },
  link: "editor-link",
};
